<template>
    <div class="map-container">
        <el-input type="text" v-model="selectedLocation" readonly placeholder="点击选择位置">
            <el-button @click="showMap" size="mini" slot="append" icon="el-icon-map-location"></el-button>
        </el-input>

        <div v-if="dialogVisible" class="mask"></div> <!-- 添加蒙版 -->

        <div v-if="dialogVisible" class="map-dialog" style="height: 680px; width: 1024px">
            <div style="display: flex;align-items: center; justify-content: space-between;">
                <h3>{{ header }}</h3>
                <div style="display: flex;justify-content: center;">
                    <div v-if="!disabled" style="margin-right: 10px;">
                        <el-button v-if="!isDrawingPolygon" type="primary" @click="startDrawingPolygon">开始绘制多边形</el-button>
                        <el-button v-else @click="finishDrawing">完成绘制</el-button>
                        <el-button @click="clearDrawing">清除</el-button>
                    </div>
                    <el-button @click="cancelSelection">取消</el-button>
                </div>
            </div>
            <div id="amap"
                style="width: 100%; height: 560px; border-radius: 8px; box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3); background-color: #fff;">
            </div>
            <div class="map-controls">
                <!-- <el-button v-if="!isDrawingPolygon" @click="startDrawingPolygon">开始绘制多边形</el-button>
                <el-button v-else @click="finishDrawing">完成绘制</el-button>
                <el-button @click="clearDrawing">清除</el-button>
                <el-button @click="cancelSelection">取消</el-button> -->
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'MyMap',
    props: {
        initialPolygon: {
            type: String,
            default: ''
        },
        header: {
            type: String,
            default: ''
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            map: null,
            polygon: null,
            points: [],
            markers: [],
            dialogVisible: false,
            selectedLocation: this.initialPolygon || '',
            isDrawingPolygon: false,
        };
    },
    mounted() {
    },
    methods: {
        showMap() {
            this.dialogVisible = true;
            this.polygon = null;
            this.$nextTick(() => {
                this.initMap();
            });
        },
        initMap() {
            this.map = new AMap.Map('amap', {
                zoom: 11,
                center: this.initialPolygon ? [parseFloat(this.initialPolygon.split(';')[0].split(',')[0]), parseFloat(this.initialPolygon.split(';')[0].split(',')[1])] : [117.0702181, 36.6663163],
            });

            if (this.initialPolygon) {
                this.points = this.initialPolygon.split(';').map(point => ({
                    lng: parseFloat(point.split(',')[0]),
                    lat: parseFloat(point.split(',')[1]),
                }));
                if (this.points.length > 2) {
                    this.drawPolygon(this.points);
                }
                this.points.forEach(point => {
                    this.addMarker(point);
                });
            }

            this.map.on('click', (e) => {
                if (this.isDrawingPolygon) {
                    const point = {
                        lng: e.lnglat.lng,
                        lat: e.lnglat.lat,
                    };
                    this.points.push(point);
                    this.updatePolygon(this.points);
                    this.addMarker(point);
                }
            });
        },
        startDrawingPolygon() {
            this.isDrawingPolygon = true;
            this.clearDrawing();
        },
        finishDrawing() {
            if (this.points.length < 3) {
                this.$message.error('请至少绘制三个点');
                return;
            }
            if (this.points.length > 16) {
                this.$message.error('请至多选择十六个点');
                return;
            }
            this.selectedLocation = this.points.map(point => `${point.lng},${point.lat}`).join(';');
            this.$emit('line-selected', this.selectedLocation);
            this.dialogVisible = false;
            this.isDrawingPolygon = false;
            // this.clearDrawing();
        },
        clearDrawing() {
            this.selectedLocation = null;
            this.$emit('line-selected', this.selectedLocation);
            this.points = [];
            if (this.polygon) {
                this.polygon.setMap(null);
                this.polygon = null;
            }
            this.markers.forEach(marker => marker.setMap(null));
            this.markers = [];
        },
        cancelSelection() {
            this.dialogVisible = false;
            this.isDrawingPolygon = false;
        },
        drawPolygon(points) {
            console.log(points.length)
            if (points.length < 3) return;
            if (!this.polygon) {
                this.polygon = new AMap.Polygon({
                    path: points.map(point => [point.lng, point.lat]),
                    fillColor: '#3366FF',
                    fillOpacity: 0.5,
                    strokeColor: '#3366FF',
                    strokeOpacity: 1,
                    strokeWeight: 3,
                    strokeDasharray: [10, 5],
                    lineJoin: 'round',
                });
                this.polygon.setMap(this.map);
            } else {
                this.polygon.setPath(points.map(point => [point.lng, point.lat]));
            }
        },
        updatePolygon(points) {
            if (this.polygon) {
                this.polygon.setPath(points.map(point => [point.lng, point.lat]));
            }
            else {
                this.drawPolygon(points);
            }
        },
        addMarker(point) {
            const marker = new AMap.Marker({
                position: new AMap.LngLat(point.lng, point.lat),
                map: this.map,
            });
            this.markers.push(marker);
        },
    },
    watch: {
        initialPolygon(newVal) {
            if (newVal) {
                console.log('map-polygon')
                this.selectedLocation = newVal;
                let data = newVal.split(';').map(point => ({
                    lng: parseFloat(point.split(',')[0]),
                    lat: parseFloat(point.split(',')[1]),
                }));
                this.updatePolygon(data);
                data.map(point => this.addMarker(point))
            } else if (this.initialPolygon) {

            } else {
                this.selectedLocation = null;
                this.clearDrawing();
                // this.isDrawingPolygon = false;
            }
        },
    },
};
</script>

<style scoped>
.map-dialog {
    position: fixed;
    top: 20%;
    left: 50%;
    transform: translate(-50%, -10%);

    background-color: white;
    padding: 20px;
    border: 1px solid #ccc;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    z-index: 1000;

    height: 600px;
    width: 1100px;
    border-radius: 10px;
}

.map-container {
    position: relative;
}

.map-controls {
    position: absolute;
    bottom: 10px;
    right: 20px;
    z-index: 1000;
}

.mask {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.3);
    z-index: 10;
    /* 确保在弹出框下方 */
    display: block;
    /* 显示蒙版 */
}
</style>